// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.content_pJI6O {
  width: 100%;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
  max-width: 546px;
  background-color: var(--white-background);
  border-radius: 12px;
  box-shadow: 0 4px 6px var(--_0000001a-shadow);
  overflow: hidden;

  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 4;

  &.expand_G3vL1 {
    max-width: 735px;
    @media (width<=768px) {
      max-width: 100vw;
      width: 100vw;
      height: 100vh;
      max-height: 100vh;
      border-radius: 0;
      -webkit-border-radius: 0;
      -moz-border-radius: 0;
      -ms-border-radius: 0;
      -o-border-radius: 0;
    }
  }
}

.scaleInitial_ahPPG {
  transform: translate(-50%, -50%) scale(0);
  opacity: 0;
}

.scaleIn_sWsMq {
  transform: translate(-50%, -50%) scale(1);
  opacity: 1;
  transition: transform 0.3s ease-out, opacity 0.3s ease-out;
}

.scaleOut_oDNFb {
  transform: translate(-50%, -50%) scale(0);
  opacity: 0;
  transition: transform 0.3s ease-in, opacity 0.3s ease-in;
}

.expand_G3vL1 {
  max-width: 735px;
}
.iniAutomateContainer_ssOd2 {
  width: 735px;
}
.automateContainer_YpzQd {
  width: 530px;
}

.iniContainer_V3CIU {
  padding: 0 22px;
  box-sizing: border-box;
  background-color: var(--f5-background);
}


 .cardsContainer_weHMq {
  display: flex;
  flex-direction: column;
  gap: 12px; 
  /* padding: 16px;  */
  background-color: var(f5);
   overflow: hidden;
  transition: max-height 1s ease; /* Animación suave si querés */
   max-height: 0px; /* Comienza colapsado */
}

.cardContainerOpen_KlID0 {
  max-height: 500px; /* Estimación suficientemente grande */
 
}

.animation_AlCeE {
  padding: 16px; 
  overflow: visible;
}

.chevronIcon_DSmoI{
  transition: transform 1s ease;
}

.rotated_p5WSt {
  transform: rotate(180deg);
}

/* @media (max-width: 1024px) {
  .cardsContainer {
    grid-template-columns: repeat(2, 1fr); 
  }
}
@media (max-width: 600px) {
  .cardsContainer {
    grid-template-columns: 1fr; 
  }
} */

.content_pJI6O::-webkit-scrollbar {
  display: none;
}

.footer_F_4jG {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  background-color: var(--f5-background);
  box-sizing: border-box;
  padding: 10px 0px;

  @media (width<=528px) {
    & {
      padding: 30px 10px 22px 10px;
    }
  }
}





.scaleDown_ov2tV {
  animation: scaleDown_ov2tV 300ms ease-in forwards;
  -webkit-animation: scaleDown_ov2tV 300ms ease-in forwards;
  animation-fill-mode: forwards
}

@keyframes scaleUp_mUttT {
  from {
    transform: translate(-50%, -50%) scale(0);
    -webkit-transform: translate(-50%, -50%) scale(0);
    -moz-transform: translate(-50%, -50%) scale(0);
    -ms-transform: translate(-50%, -50%) scale(0);
    -o-transform: translate(-50%, -50%) scale(0);
  }

  to {
    transform: translate(-50%, -50%) scale(1);
    -webkit-transform: translate(-50%, -50%) scale(1);
    -moz-transform: translate(-50%, -50%) scale(1);
    -ms-transform: translate(-50%, -50%) scale(1);
    -o-transform: translate(-50%, -50%) scale(1);
  }
}

@keyframes scaleDown_ov2tV {
  from {
    transform: translate(-50%, -50%) scale(1);
  }

  to {
    transform: translate(-50%, -50%) scale(0);
    -webkit-transform: translate(-50%, -50%) scale(0);
    -moz-transform: translate(-50%, -50%) scale(0);
    -ms-transform: translate(-50%, -50%) scale(0);
    -o-transform: translate(-50%, -50%) scale(0);
  }
}

.fadeOut_xZ2ta {
  opacity: 0;
}



.headerLeft_hKChN {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  color: var(--_2-color);
  font-size: 20px;
  font-weight: 600;
  gap: 33px;
  width: 100%;

  h2 {
    font-size: 22px;
    font-weight: 600;
    color: var(--black-color);
  }

  b {
    margin-left: auto;
  }
}

.closeIcon_Wiaqs {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 31px;
  height: 31px;
  cursor: pointer;
  border-radius: 4px;
  background: var(--f6-background);
  -webkit-user-select: none;
          user-select: none;
}

.backButton_Z4p0G {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  width: 23px;
  height: 23px;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  background: var(--_10a37f-background);
}

.closeIcon_Wiaqs {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 31px;
  height: 31px;
  cursor: pointer;
  border-radius: 4px;
  background: var(--f6-background);
  -webkit-user-select: none;
          user-select: none;
}

.searchContainer_q5IsX {
  display: flex;
  gap: 10px;
  align-items: center;
}

.searchInputWrapper_KtW05 {
  display: flex;
  align-items: center;
  background: var(--white-background);
  height: 35px;
  width: 100%;
  min-height: 35px;
  border: 1px solid var(--d9d9e3-border);
  border-radius: 8px;
  padding: 0px 14px;
  margin-left: 15px;
}

.searchIconsWrappers_hpLiv {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  background: var(--ececf1-background);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border-radius: 3px;
}

.searchIcon_ahbm3 {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  color: var(--_6-color);
}

.searchInput_sBdbG {
  flex: 1 1;
  padding: 8px;
  border: none;
  background: transparent;  
  outline: none;
}

.searchInput_sBdbG::placeholder {
  color: var(--_6-color);
}


.contentContainerScroll_jsbti {
  overflow: hidden;
  overflow-y: auto;
}
.contentContainer_aWDHZ {
  border: 2px dashed var(--ececf1-background);
  border-radius: 8px;
  max-height: 60vh;
}

.contentContainer_aWDHZ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.contentContainer_aWDHZ::-webkit-scrollbar-thumb {
  background-color: var(--e2-background);
  border-radius: 12px;
}

.contentContainer_aWDHZ::-webkit-scrollbar-track {
  background: var(--white-background);
}

.noAutomations_QK_lr {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  flex-direction: column;
  padding: 20px;
  background-color: var(--white-background);
}


.paginationTableContainer_JGByD{
  display: flex;
  justify-content: end;
  width: 100%;
}
.automationIconContainer_J4e1D{
  background-color: var(--f5-background);
  transition: background-color 0.3s ease;
  border-radius: 5px;
  cursor: pointer;
  stroke: rgb(119, 119, 119) !important;
  svg{
    &:hover {
      stroke: #8f8f8f !important;
    }
  }
}

.noAutomationsTextWrapper_J9R4P{
      display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 1%;
}

.scaleUp_mUttT {
  transform: scale(0.08);
  opacity: 0;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.exploreContainer_xryYO{
  background-color: var(--white-background);
  border-radius: 20px 0px 0px 0px;
  overflow: scroll;
  width: 100%;
}


.typeContact_tb1cJ {
  display: flex;
  background-color: var(--white-background);
  border-radius: 6px;
  -webkit-border-radius: 6px;
  -moz-border-radius: 6px;
  -ms-border-radius: 6px;
  -o-border-radius: 6px;
  padding: 12px 20px;
  gap: 20px;
  width: 100%;
  height: fit-content;
  box-sizing: border-box;
  overflow-x: auto;


  button {
    background-color: transparent;
    cursor: pointer;
    color: var(--_6-color);
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 24px;
    border-radius: 8px;
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    -ms-border-radius: 8px;
    -o-border-radius: 8px;
    /* border: 1px solid transparent !important; */
    border: none !important;
    /* flex: 1; */
    background-color: transparent;
    max-height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 8px;
    outline: none;
}

 .selected_lEuQA {
    background-color: var(--ececf1-background);
    /* color: var(--_0d-color); */
    border-radius: 8px;
    border:none !important;
    box-shadow:
      0px 0px 2px 0px var(--_00000008-shadow),
      0px 0px 0px 0px var(--_00000000-shadow),
      0px 0px 0px 0px var(--_00000000-shadow);
  }
}

.boxContainer_m0wX2{
  display: flex;
  gap: 10px;
    padding: 20px 15px 10px 15px;
 
  .box_wGrSE{
 border: 1px solid #d9d9d9;
  border-radius: 8px;
          width: 100%;
    .firstLine_lhfK3{
      display: flex;
      justify-content: space-between;
      margin: 7px;
      .left_yR1UC{
        font-weight: bold;
      }
      .right_rbuHE{
        .colorGreen_Wvg6M{
          color:#01C67A
        }
        .colorGrey_O8zfI{
          color: #8C90A2;
        }
       
      }
    }
    .secondLine_pgNYy{
 display: flex;
 justify-content: space-between;
 align-items: center;
 margin: 7px;
      .left_yR1UC{

      }
      .right_rbuHE{
        font-size: 35px;
        font-weight: bold;
      }
    }

  }
}

.subTitle_LyuGI{
  display: flex;
  align-items: center;
  gap: 10px;
  height:15px;
  margin-left: 15px;
}



.showMoreContainer_K3gYp {
  display: flex;
  align-items: center;
  gap: 20px;
  padding: 15px;
  cursor: pointer;

  .showMore_QuTDr{
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  white-space: nowrap;
  font-weight: bold;
  color: #10A37F;
  font-size: 14px;
}

.linea_YVxmt {
  flex: 1 1;
  height: 1px;
  background-color: #ccc;
}
}

.buttonsContainer_lT9SY{
  display:flex;
  justify-content: space-between;
  .buttonsRight_pHX3u{
    display: flex;
    align-items: center;
    gap: 10px;
    margin-right: 15px;
  }
}

.subTitleContainer_H_qR8{
  display: flex;
  justify-content: space-between;
  align-items:center;
}

.IconA_jMibG{
  color: #6E6E80;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/views/Dashboard/screens/ChatView/ExploreCommuniti/ExploreCommuniti.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,yCAAyC;EACzC,mBAAmB;EACnB,6CAA6C;EAC7C,gBAAgB;;EAEhB,eAAe;EACf,QAAQ;EACR,SAAS;EACT,UAAU;;EAEV;IACE,gBAAgB;IAChB;MACE,gBAAgB;MAChB,YAAY;MACZ,aAAa;MACb,iBAAiB;MACjB,gBAAgB;MAChB,wBAAwB;MACxB,qBAAqB;MACrB,oBAAoB;MACpB,mBAAmB;IACrB;EACF;AACF;;AAEA;EACE,yCAAyC;EACzC,UAAU;AACZ;;AAEA;EACE,yCAAyC;EACzC,UAAU;EACV,0DAA0D;AAC5D;;AAEA;EACE,yCAAyC;EACzC,UAAU;EACV,wDAAwD;AAC1D;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,sCAAsC;AACxC;;;CAGC;EACC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,oBAAoB;EACpB,yBAAyB;GACxB,gBAAgB;EACjB,8BAA8B,EAAE,8BAA8B;GAC7D,eAAe,EAAE,uBAAuB;AAC3C;;AAEA;EACE,iBAAiB,EAAE,sCAAsC;;AAE3D;;AAEA;EACE,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;;;;;;GASG;;AAEH;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,sCAAsC;EACtC,sBAAsB;EACtB,iBAAiB;;EAEjB;IACE;MACE,4BAA4B;IAC9B;EACF;AACF;;;;;;AAMA;EACE,iDAA2C;EAC3C,yDAAmD;EACnD;AACF;;AAEA;EACE;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;;EAEA;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;AACF;;AAEA;EACE;IACE,yCAAyC;EAC3C;;EAEA;IACE,yCAAyC;IACzC,iDAAiD;IACjD,8CAA8C;IAC9C,6CAA6C;IAC7C,4CAA4C;EAC9C;AACF;;AAEA;EACE,UAAU;AACZ;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,WAAW;;EAEX;IACE,eAAe;IACf,gBAAgB;IAChB,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,gCAAgC;EAChC,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mCAAmC;EACnC,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;;AAGA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,sBAAsB;EACtB,aAAa;EACb,yCAAyC;AAC3C;;;AAGA;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;AACb;AACA;EACE,sCAAsC;EACtC,sCAAsC;EACtC,kBAAkB;EAClB,eAAe;EACf,qCAAqC;EACrC;IACE;MACE,0BAA0B;IAC5B;EACF;AACF;;AAEA;MACM,aAAa;IACf,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;EACE,sBAAsB;EACtB,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,yCAAyC;EACzC,+BAA+B;EAC/B,gBAAgB;EAChB,WAAW;AACb;;;AAGA;EACE,aAAa;EACb,yCAAyC;EACzC,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;;;EAGhB;IACE,6BAA6B;IAC7B,eAAe;IACf,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;IAClB,0BAA0B;IAC1B,uBAAuB;IACvB,sBAAsB;IACtB,qBAAqB;IACrB,8CAA8C;IAC9C,uBAAuB;IACvB,aAAa;IACb,6BAA6B;IAC7B,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,aAAa;AACjB;;CAEC;IACG,0CAA0C;IAC1C,6BAA6B;IAC7B,kBAAkB;IAClB,sBAAsB;IACtB;;;6CAGyC;EAC3C;AACF;;AAEA;EACE,aAAa;EACb,SAAS;IACP,4BAA4B;;EAE9B;CACD,yBAAyB;EACxB,kBAAkB;UACV,WAAW;IACjB;MACE,aAAa;MACb,8BAA8B;MAC9B,WAAW;MACX;QACE,iBAAiB;MACnB;MACA;QACE;UACE;QACF;QACA;UACE,cAAc;QAChB;;MAEF;IACF;IACA;CACH,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;CACnB,WAAW;MACN;;MAEA;MACA;QACE,eAAe;QACf,iBAAiB;MACnB;IACF;;EAEF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,iBAAiB;AACnB;;;;AAIA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,eAAe;;EAEf;EACA,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,WAAW;EACX,sBAAsB;AACxB;AACA;;AAEA;EACE,YAAY;EACZ,8BAA8B;EAC9B;IACE,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;EACpB;AACF;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB","sourcesContent":[".content {\n  width: 100%;\n  max-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  max-width: 546px;\n  background-color: var(--white-background);\n  border-radius: 12px;\n  box-shadow: 0 4px 6px var(--_0000001a-shadow);\n  overflow: hidden;\n\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  z-index: 4;\n\n  &.expand {\n    max-width: 735px;\n    @media (width<=768px) {\n      max-width: 100vw;\n      width: 100vw;\n      height: 100vh;\n      max-height: 100vh;\n      border-radius: 0;\n      -webkit-border-radius: 0;\n      -moz-border-radius: 0;\n      -ms-border-radius: 0;\n      -o-border-radius: 0;\n    }\n  }\n}\n\n.scaleInitial {\n  transform: translate(-50%, -50%) scale(0);\n  opacity: 0;\n}\n\n.scaleIn {\n  transform: translate(-50%, -50%) scale(1);\n  opacity: 1;\n  transition: transform 0.3s ease-out, opacity 0.3s ease-out;\n}\n\n.scaleOut {\n  transform: translate(-50%, -50%) scale(0);\n  opacity: 0;\n  transition: transform 0.3s ease-in, opacity 0.3s ease-in;\n}\n\n.expand {\n  max-width: 735px;\n}\n.iniAutomateContainer {\n  width: 735px;\n}\n.automateContainer {\n  width: 530px;\n}\n\n.iniContainer {\n  padding: 0 22px;\n  box-sizing: border-box;\n  background-color: var(--f5-background);\n}\n\n\n .cardsContainer {\n  display: flex;\n  flex-direction: column;\n  gap: 12px; \n  /* padding: 16px;  */\n  background-color: var(f5);\n   overflow: hidden;\n  transition: max-height 1s ease; /* Animación suave si querés */\n   max-height: 0px; /* Comienza colapsado */\n}\n\n.cardContainerOpen {\n  max-height: 500px; /* Estimación suficientemente grande */\n \n}\n\n.animation {\n  padding: 16px; \n  overflow: visible;\n}\n\n.chevronIcon{\n  transition: transform 1s ease;\n}\n\n.rotated {\n  transform: rotate(180deg);\n}\n\n/* @media (max-width: 1024px) {\n  .cardsContainer {\n    grid-template-columns: repeat(2, 1fr); \n  }\n}\n@media (max-width: 600px) {\n  .cardsContainer {\n    grid-template-columns: 1fr; \n  }\n} */\n\n.content::-webkit-scrollbar {\n  display: none;\n}\n\n.footer {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 4px;\n  background-color: var(--f5-background);\n  box-sizing: border-box;\n  padding: 10px 0px;\n\n  @media (width<=528px) {\n    & {\n      padding: 30px 10px 22px 10px;\n    }\n  }\n}\n\n\n\n\n\n.scaleDown {\n  animation: scaleDown 300ms ease-in forwards;\n  -webkit-animation: scaleDown 300ms ease-in forwards;\n  animation-fill-mode: forwards\n}\n\n@keyframes scaleUp {\n  from {\n    transform: translate(-50%, -50%) scale(0);\n    -webkit-transform: translate(-50%, -50%) scale(0);\n    -moz-transform: translate(-50%, -50%) scale(0);\n    -ms-transform: translate(-50%, -50%) scale(0);\n    -o-transform: translate(-50%, -50%) scale(0);\n  }\n\n  to {\n    transform: translate(-50%, -50%) scale(1);\n    -webkit-transform: translate(-50%, -50%) scale(1);\n    -moz-transform: translate(-50%, -50%) scale(1);\n    -ms-transform: translate(-50%, -50%) scale(1);\n    -o-transform: translate(-50%, -50%) scale(1);\n  }\n}\n\n@keyframes scaleDown {\n  from {\n    transform: translate(-50%, -50%) scale(1);\n  }\n\n  to {\n    transform: translate(-50%, -50%) scale(0);\n    -webkit-transform: translate(-50%, -50%) scale(0);\n    -moz-transform: translate(-50%, -50%) scale(0);\n    -ms-transform: translate(-50%, -50%) scale(0);\n    -o-transform: translate(-50%, -50%) scale(0);\n  }\n}\n\n.fadeOut {\n  opacity: 0;\n}\n\n\n\n.headerLeft {\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  color: var(--_2-color);\n  font-size: 20px;\n  font-weight: 600;\n  gap: 33px;\n  width: 100%;\n\n  h2 {\n    font-size: 22px;\n    font-weight: 600;\n    color: var(--black-color);\n  }\n\n  b {\n    margin-left: auto;\n  }\n}\n\n.closeIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 31px;\n  height: 31px;\n  cursor: pointer;\n  border-radius: 4px;\n  background: var(--f6-background);\n  user-select: none;\n}\n\n.backButton {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  width: 23px;\n  height: 23px;\n  cursor: pointer;\n  user-select: none;\n  background: var(--_10a37f-background);\n}\n\n.closeIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 31px;\n  height: 31px;\n  cursor: pointer;\n  border-radius: 4px;\n  background: var(--f6-background);\n  user-select: none;\n}\n\n.searchContainer {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.searchInputWrapper {\n  display: flex;\n  align-items: center;\n  background: var(--white-background);\n  height: 35px;\n  width: 100%;\n  min-height: 35px;\n  border: 1px solid var(--d9d9e3-border);\n  border-radius: 8px;\n  padding: 0px 14px;\n  margin-left: 15px;\n}\n\n.searchIconsWrappers {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 22px;\n  height: 22px;\n  background: var(--ececf1-background);\n  cursor: pointer;\n  user-select: none;\n  border-radius: 3px;\n}\n\n.searchIcon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 24px;\n  height: 24px;\n  color: var(--_6-color);\n}\n\n.searchInput {\n  flex: 1;\n  padding: 8px;\n  border: none;\n  background: transparent;  \n  outline: none;\n}\n\n.searchInput::placeholder {\n  color: var(--_6-color);\n}\n\n\n.contentContainerScroll {\n  overflow: hidden;\n  overflow-y: auto;\n}\n.contentContainer {\n  border: 2px dashed var(--ececf1-background);\n  border-radius: 8px;\n  max-height: 60vh;\n}\n\n.contentContainer::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.contentContainer::-webkit-scrollbar-thumb {\n  background-color: var(--e2-background);\n  border-radius: 12px;\n}\n\n.contentContainer::-webkit-scrollbar-track {\n  background: var(--white-background);\n}\n\n.noAutomations {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  flex-direction: column;\n  padding: 20px;\n  background-color: var(--white-background);\n}\n\n\n.paginationTableContainer{\n  display: flex;\n  justify-content: end;\n  width: 100%;\n}\n.automationIconContainer{\n  background-color: var(--f5-background);\n  transition: background-color 0.3s ease;\n  border-radius: 5px;\n  cursor: pointer;\n  stroke: rgb(119, 119, 119) !important;\n  svg{\n    &:hover {\n      stroke: #8f8f8f !important;\n    }\n  }\n}\n\n.noAutomationsTextWrapper{\n      display: flex;\n    flex-direction: column;\n    align-items: center;\n    margin-bottom: 1%;\n}\n\n.scaleUp {\n  transform: scale(0.08);\n  opacity: 0;\n  transition: transform 0.3s ease, opacity 0.3s ease;\n}\n\n.exploreContainer{\n  background-color: var(--white-background);\n  border-radius: 20px 0px 0px 0px;\n  overflow: scroll;\n  width: 100%;\n}\n\n\n.typeContact {\n  display: flex;\n  background-color: var(--white-background);\n  border-radius: 6px;\n  -webkit-border-radius: 6px;\n  -moz-border-radius: 6px;\n  -ms-border-radius: 6px;\n  -o-border-radius: 6px;\n  padding: 12px 20px;\n  gap: 20px;\n  width: 100%;\n  height: fit-content;\n  box-sizing: border-box;\n  overflow-x: auto;\n\n\n  button {\n    background-color: transparent;\n    cursor: pointer;\n    color: var(--_6-color);\n    font-family: Inter;\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: 24px;\n    border-radius: 8px;\n    -webkit-border-radius: 8px;\n    -moz-border-radius: 8px;\n    -ms-border-radius: 8px;\n    -o-border-radius: 8px;\n    /* border: 1px solid transparent !important; */\n    border: none !important;\n    /* flex: 1; */\n    background-color: transparent;\n    max-height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 8px;\n    outline: none;\n}\n\n .selected {\n    background-color: var(--ececf1-background);\n    /* color: var(--_0d-color); */\n    border-radius: 8px;\n    border:none !important;\n    box-shadow:\n      0px 0px 2px 0px var(--_00000008-shadow),\n      0px 0px 0px 0px var(--_00000000-shadow),\n      0px 0px 0px 0px var(--_00000000-shadow);\n  }\n}\n\n.boxContainer{\n  display: flex;\n  gap: 10px;\n    padding: 20px 15px 10px 15px;\n \n  .box{\n border: 1px solid #d9d9d9;\n  border-radius: 8px;\n          width: 100%;\n    .firstLine{\n      display: flex;\n      justify-content: space-between;\n      margin: 7px;\n      .left{\n        font-weight: bold;\n      }\n      .right{\n        .colorGreen{\n          color:#01C67A\n        }\n        .colorGrey{\n          color: #8C90A2;\n        }\n       \n      }\n    }\n    .secondLine{\n display: flex;\n justify-content: space-between;\n align-items: center;\n margin: 7px;\n      .left{\n\n      }\n      .right{\n        font-size: 35px;\n        font-weight: bold;\n      }\n    }\n\n  }\n}\n\n.subTitle{\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  height:15px;\n  margin-left: 15px;\n}\n\n\n\n.showMoreContainer {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  padding: 15px;\n  cursor: pointer;\n\n  .showMore{\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  white-space: nowrap;\n  font-weight: bold;\n  color: #10A37F;\n  font-size: 14px;\n}\n\n.linea {\n  flex: 1;\n  height: 1px;\n  background-color: #ccc;\n}\n}\n\n.buttonsContainer{\n  display:flex;\n  justify-content: space-between;\n  .buttonsRight{\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    margin-right: 15px;\n  }\n}\n\n.subTitleContainer{\n  display: flex;\n  justify-content: space-between;\n  align-items:center;\n}\n\n.IconA{\n  color: #6E6E80;\n  font-size: 12px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"content": `content_pJI6O`,
	"expand": `expand_G3vL1`,
	"scaleInitial": `scaleInitial_ahPPG`,
	"scaleIn": `scaleIn_sWsMq`,
	"scaleOut": `scaleOut_oDNFb`,
	"iniAutomateContainer": `iniAutomateContainer_ssOd2`,
	"automateContainer": `automateContainer_YpzQd`,
	"iniContainer": `iniContainer_V3CIU`,
	"cardsContainer": `cardsContainer_weHMq`,
	"cardContainerOpen": `cardContainerOpen_KlID0`,
	"animation": `animation_AlCeE`,
	"chevronIcon": `chevronIcon_DSmoI`,
	"rotated": `rotated_p5WSt`,
	"footer": `footer_F_4jG`,
	"scaleDown": `scaleDown_ov2tV`,
	"fadeOut": `fadeOut_xZ2ta`,
	"headerLeft": `headerLeft_hKChN`,
	"closeIcon": `closeIcon_Wiaqs`,
	"backButton": `backButton_Z4p0G`,
	"searchContainer": `searchContainer_q5IsX`,
	"searchInputWrapper": `searchInputWrapper_KtW05`,
	"searchIconsWrappers": `searchIconsWrappers_hpLiv`,
	"searchIcon": `searchIcon_ahbm3`,
	"searchInput": `searchInput_sBdbG`,
	"contentContainerScroll": `contentContainerScroll_jsbti`,
	"contentContainer": `contentContainer_aWDHZ`,
	"noAutomations": `noAutomations_QK_lr`,
	"paginationTableContainer": `paginationTableContainer_JGByD`,
	"automationIconContainer": `automationIconContainer_J4e1D`,
	"noAutomationsTextWrapper": `noAutomationsTextWrapper_J9R4P`,
	"scaleUp": `scaleUp_mUttT`,
	"exploreContainer": `exploreContainer_xryYO`,
	"typeContact": `typeContact_tb1cJ`,
	"selected": `selected_lEuQA`,
	"boxContainer": `boxContainer_m0wX2`,
	"box": `box_wGrSE`,
	"firstLine": `firstLine_lhfK3`,
	"left": `left_yR1UC`,
	"right": `right_rbuHE`,
	"colorGreen": `colorGreen_Wvg6M`,
	"colorGrey": `colorGrey_O8zfI`,
	"secondLine": `secondLine_pgNYy`,
	"subTitle": `subTitle_LyuGI`,
	"showMoreContainer": `showMoreContainer_K3gYp`,
	"showMore": `showMore_QuTDr`,
	"linea": `linea_YVxmt`,
	"buttonsContainer": `buttonsContainer_lT9SY`,
	"buttonsRight": `buttonsRight_pHX3u`,
	"subTitleContainer": `subTitleContainer_H_qR8`,
	"IconA": `IconA_jMibG`
};
export default ___CSS_LOADER_EXPORT___;
